import fetch from 'isomorphic-unfetch';
import getConfig from 'next/config';

const { publicRuntimeConfig: features } = getConfig();

interface Products {
  productId: string;
  brand: string;
  availableToOrder: boolean;
}

interface FetcherOptions {
  url: string;
  products: Products[];
  appId: string;
}
const fetcher = async ({
  url,
  products,
  appId,
}: FetcherOptions): Promise<void> =>
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ products, appId }),
  })
    .then((r) => {
      if (r.ok) {
        return r.json();
      }
      throw new Error(
        `Received error fetching social proof messaging data: ${r.status}`
      );
    })
    .catch((e) => {
      throw new Error(e);
    });
export const PATH = features.socialProofAPIService;

export const fetchSocialProofData = (products: Products[]) =>
  fetcher({
    url: `${PATH}`,
    products: products,
    appId: features.productCardSocialProofAppId,
  });
